import React, { useEffect, useState } from "react";
import {
  getNotifications,
  updateNotifications,
} from "../../../store/thunks/common-thunks/commonThunk";
import { formatDate } from "../utils/Utils";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Card,
  Spin,
  Divider,
  Badge,
  Checkbox,
  Row,
  Col,
  Image,
} from "../../common/utils/antd-imports/AntdImports";
import "./Notifications.css";
import "../../../main.css";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import BackArrow from "../../../assests/back-arrow.svg";
import BreadcrumbNav from "../bread-crumbs/BreadCrumb";
import {
  addBreadcrumb,
  setBreadcrumbs,
} from "../../../store/slices/common-slice/bread-crumbs/BreadCrumbSlice";
import { CopyOutlined } from "@ant-design/icons";
import { handleCopy } from "../utils/Utils";
import BellIcon from "../../../assests/notification-bell-icon.svg";
const Notifications = () => {
  const dispatch = useDispatch();
  const { user } = JSON.parse(localStorage.getItem("user"));
  const userType = user.user_type === "owner" ? "seller" : "buyer";
  const { isNotificationsLoading } = useSelector(
    (state) => state?.notifications,
  );
  const notifications = useSelector((state) => state?.notifications || []);
  const [tabValue, setTabValue] = useState("saved_campaign");
  const navigate = useNavigate();
  const [checkedIds, setCheckedIds] = useState([]);
  const isMobile = useMediaQuery({ maxWidth: "767px" });
  const updateNotificationStatus = () => {
    dispatch(updateNotifications({ notification_ids: checkedIds }));
    dispatch(getNotifications());
    setCheckedIds([]);
  };
  const handleGoToSubPage = ({ title, path }) => {
    dispatch(
      addBreadcrumb({
        title,
        path,
      }),
    );
  };
  const handleResetBreadcrumbs = ({ title, path }) => {
    dispatch(
      setBreadcrumbs([
        {
          title: "Dashboard",
          path: `/${userType}/dashboard`,
        },
        { title, path },
      ]),
    );
  };
  const markAsReadViewButton = (id) => {
    dispatch(updateNotifications({ notification_ids: [id] })).then((res) => {
      if (res?.payload?.status == 1) dispatch(getNotifications());
    });
  };

  //  Checkbox to mark unread notifications as read
  const handleUnreadInCheckbox = (event, record) => {
    let isRecordExist = checkedIds?.find((id) => id === record?.id);
    if (event.target.checked && !isRecordExist) {
      setCheckedIds((checkedIds) => [...checkedIds, record?.id]);
    } else {
      setCheckedIds(checkedIds.filter((id) => id !== record?.id));
    }
  };

  // Navigation to different screens based on the notification type
  const viewCampaignDetails = (record) => {
    switch (record?.type) {
      case "offer_rejected":
      case "offer_accepted":
      case "transfer_campaign":
        navigate(`/${userType}/mycampaigns?segment=${tabValue}`, {
          replace: true,
        });
        markAsReadViewButton(record?.id);
        break;

      case "campaign":
        if (userType === "seller") {
          handleResetBreadcrumbs({
            title: record?.c_name,
            path: `/${userType}/viewCampaigns/campaignDetails/${btoa(
              record?.campaign_id,
            )}`,
          });
          navigate(
            `/${userType}/viewCampaigns/campaignDetails/${btoa(
              record?.campaign_id,
            )}`,
          );
        } else {
          handleGoToSubPage({
            title: record?.c_name,
            path: `/${userType}/campaigndetails?_id=${btoa(
              record?.campaign_id,
            )}`,
          });
          navigate(
            `/${userType}/campaigndetails?_id=${btoa(record?.campaign_id)}`,
          );
        }
        markAsReadViewButton(record?.id);
        break;

      case "bulk_upload":
      case "product_transfer":
        navigate(`/${userType}/myproducts`);
        markAsReadViewButton(record?.id);
        handleResetBreadcrumbs({
          title: "My Products",
          path: `/${userType}/myproducts`,
        });
        break;

      case "rfp_request":
        navigate(`/${userType}/rfpRequests`);
        markAsReadViewButton(record?.id);
        break;

      case "offer_request":
        navigate(`/${userType}/viewCampaigns`);
        markAsReadViewButton(record?.id);
        break;
      case "term_request":
        handleGoToSubPage({
          title: "Buyer Request",
          path: `/${userType}/terms-requests`,
        });
        navigate(`/${userType}/terms-requests`);
        markAsReadViewButton(record?.id);
        break;
      case "hold_request":
        if (userType === "seller") {
          handleGoToSubPage({
            title: "Buyer Request",
            path: `/${userType}/terms-requests`,
          });
          navigate(`/${userType}/terms-requests`);
        }
        markAsReadViewButton(record?.id);
        break;
    }
  };
  useEffect(() => {
    dispatch(getNotifications());
  }, [dispatch]);
  return (
    <div>
      <div>
        {!isMobile && (
          <div className="rfp-bread-crumb">
            <BreadcrumbNav />
          </div>
        )}
        {notifications?.notifications?.length > 0 ? (
          <div className="notifications-container">
            <Card className="notification-card">
              <>
                <div className="notification-main-header">
                  <div className="notification-label">
                    {isMobile && (
                      <Image
                        className="arrow-align pointer "
                        src={BackArrow}
                        preview={false}
                        onClick={() => navigate(-1)}
                      />
                    )}
                    <span className="main-title-size">All Notifications</span>
                  </div>
                </div>

                <>
                  {!isMobile && checkedIds.length > 0 && (
                    <div>
                      <Button
                        className="mark-read-btn"
                        onClick={updateNotificationStatus}
                      >
                        Mark as Read
                      </Button>
                    </div>
                  )}

                  <div className="notification-scrollable-container">
                    {notifications?.notifications?.map((notification) => {
                      return (
                        <div key={notification?.id}>
                          <Row key={notification?.id}>
                            <Col span={2}>
                              {!isMobile && (
                                <div className="notify-checkbox">
                                  <Checkbox
                                    onChange={(event) =>
                                      handleUnreadInCheckbox(
                                        event,
                                        notification,
                                      )
                                    }
                                    checked={checkedIds.includes(
                                      notification?.id,
                                    )}
                                    disabled={notification?.status === 1}
                                  />
                                </div>
                              )}
                            </Col>
                            <Col span={20} className="notify-details">
                              <div>
                                {userType == "buyer" ? (
                                  <div className="notify-desc">
                                    <span className="default-color id-size">
                                      {" "}
                                      {notification?.c_id}
                                      <CopyOutlined
                                        onClick={(e) => {
                                          e.stopPropagation(); // prevent tooltip close
                                          handleCopy(notification?.c_id);
                                        }}
                                        className="copy-icon"
                                      />
                                    </span>
                                  </div>
                                ) : (
                                  ""
                                )}
                                <div className="notify-message">
                                  {userType == "buyer" && (
                                    <span>{notification?.c_name}-</span>
                                  )}{" "}
                                  {notification?.message}
                                </div>
                                {notification?.type != "bulk_upload_pending" &&
                                  notification?.type !=
                                    "campaign_product_offer" && (
                                    <div className="view-details-date">
                                      <Button
                                        className="view-details pointer"
                                        onClick={() =>
                                          viewCampaignDetails(notification)
                                        }
                                      >
                                        View Details
                                      </Button>
                                      <div className="notify-date">
                                        {formatDate(notification?.created_at)}
                                      </div>
                                    </div>
                                  )}
                              </div>
                            </Col>
                            {/* Badge for unread notifications */}
                            <Col span={2}>
                              {notification?.status === 0 && (
                                <Badge
                                  className="new-notification-mark"
                                  dot={true}
                                  color="#d2042d"
                                />
                              )}
                            </Col>
                          </Row>
                          <Divider className="notify-divider" />
                        </div>
                      );
                    })}
                  </div>
                </>
              </>
            </Card>
          </div>
        ) : (
          <>
            <div className="empty-notifications-container">
              <Card className="empty-notifications-card">
                <div className="image-container notification-small-screen-container ">
                  <Image
                    src={BellIcon}
                    className="no-notifications-icon"
                    preview={false}
                  />
                </div>
                <div className="content-section">
                  <div className="no-new-header">No New Notifications Yet!</div>
                  <span className="sub-message sub-text-size">
                    Stay tuned! Any updates about your campaigns, offers, or
                    transfers will show up right here.
                  </span>
                </div>
              </Card>
            </div>
          </>
        )}
      </div>
      {isNotificationsLoading && (
        <div className="loading-css">
          <Spin size="large" fullscreen />
        </div>
      )}
    </div>
  );
};

export default Notifications;
